import * as STD                            from '@emersya/mpa-std-lib';

import CM                   from '@emersya/mpa-components-manager-lib';
import { Link, Image, Text } from '@emersya/mpa-components-lib';

export interface IStandingPDFAccessoriesComponentConfiguration extends CM.DOMComponent.IConfiguration {
	imgSource : string;
	linkSource : Record<string,STD.translationsManager.TranslationMapping>;
	text :  STD.translationsManager.TranslationMapping;
};

export class StandingPDFAccessoriesComponent extends CM.DOMComponent<
HTMLDivElement,
StandingPDFAccessoriesComponent,
IStandingPDFAccessoriesComponentConfiguration
> {

	component_DOM : HTMLDivElement;

	async changeLanguageLink(){
		const link = <Link.Component>this.component_find('@:linkPDFAccessories');
		const product = app.currentProduct;
		if(!product || !product.id){
			return;
		}
		const linkSource = this.component_configuration.linkSource[app.currentProduct.id];
		if(!linkSource){
			this.component_throwUserError('Missing PDF for product : '+product.id);
		}
		let newHref = linkSource[ app.currentLanguage ];
		if (!newHref || newHref === '') {
			newHref = '';
			this.component_DOM.classList.add('notReady');
		}else{
			this.component_DOM.classList.remove('notReady');
		}
		link.updateHref(newHref);
	}

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingPDFAccessoriesComponentConfiguration
	)
	{
		const trIcon = STD.translationsManager.languages.reduce<Record<string, string>>((a, c) => {
			a[ c ] = 'iconPDFAccessories';
			return a;
		}, {});
		configuration['@innerConfigurations'] = {
			linkPDFAccessories : <Link.Configuration> {
				href : configuration.linkSource[app.currentLanguage],
				target : '_blank',
				'@translations' : {

				},
				'@innerConfigurations' : {
					image : <Image.Configuration>{
						URL : configuration.imgSource,
						'@translations' : {
							'name' : trIcon
						}
					},
					title : <Text.Configuration>{
						'@translations' : {
							'text' : configuration.text
						}
					}
				}
			},
		};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});

	};
};
export namespace NS {
	export const Component = StandingPDFAccessoriesComponent;
	export type Component = StandingPDFAccessoriesComponent;
	export type Configuration = IStandingPDFAccessoriesComponentConfiguration;
}
import manifestXMLSource    from './StandingPDFAccessories.xml';
import './StandingPDFAccessories.scss';

CM.declare({
	id :       'standing-pdfAccessories',
	type :     StandingPDFAccessoriesComponent,
	manifest : manifestXMLSource
});
